// TODO: Move the imported types into this file to avoid a ciruclar dependency warning.
// Also Alignment, etc can be defined directly and have AdvancedTableColumnConfig use them instead of the reverse like now.
// Context: Zach was trying to make type-doc work better, but it's probably not worth the weird organization.

var SortDirections;
(function (SortDirections) {
  SortDirections["Ascending"] = "ascending";
  SortDirections["Descending"] = "descending";
  SortDirections["None"] = "none";
})(SortDirections || (SortDirections = {}));
var Alignments;
(function (Alignments) {
  Alignments["Left"] = "left";
  Alignments["Right"] = "right";
  Alignments["Center"] = "center";
})(Alignments || (Alignments = {}));

export { Alignments, SortDirections };
